"use client";
import React from "react";
import Expert from "../Images/why_expertise.png";
import Expert1 from "../Images/why_personalized.png";
import Expert2 from "../Images/why_technology.png";
import Expert3 from "../Images/why_compliance.png";
import Expert4 from "../Images/why_strategy.png";
import Expert5 from "../Images/why_risk.png";

function WhyChooseUs() {
  return (
    <section className="why-section">
      <div className="container">
        
        {/* HEADING */}
        <h2 className="main-title">
          <span>Why Choose ComplianceKare</span>
        </h2>

        {/* CARDS */}
        <div className="row g-4">
          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <div className="why-img-wrapper">
                <img src={Expert} alt="" />
              </div>
              <h4>Expertise</h4>
              <p>
                Our team comprises seasoned tax professionals certified and knowledgeable Experts with in-depth knowledge of tax laws, regulations, and a proven track record of delivering accurate and reliable financial services.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <div className="why-img-wrapper">
                <img src={Expert1} alt="" />
              </div>
              <h4>Personalized Approach</h4>
              <p>
                We understand that every business is unique. That's why we take the time to understand your specific requirements and craft customized solutions to address your financial challenges.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <div className="why-img-wrapper">
                <img src={Expert2} alt="" />
              </div>
              <h4>Technology Integration</h4>
              <p>
                Embracing cutting-edge accounting technologies, we ensure efficiency, accuracy, and security in handling your financial data.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <div className="why-img-wrapper">
                <img src={Expert3} alt="" />
              </div>
              <h4>Compliance Assurance</h4>
              <p>
                Stay ahead of regulatory changes and tax obligations with our expert guidance, ensuring that your business remains in full compliance with applicable laws.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <div className="why-img-wrapper">
                <img src={Expert4} alt="" />
              </div>
              <h4>Strategic Planning</h4>
              <p>
                Beyond compliance, we focus on strategic tax planning to help you make informed financial decisions and optimize your tax position.
              </p>
            </div>
          </div>

          <div className="col-md-4 col-sm-6">
            <div className="why-card">
              <div className="why-img-wrapper">
                <img src={Expert5} alt="" />
              </div>
              <h4>Risk Mitigation</h4>
              <p>
                We focus on proactive risk management, helping businesses identify and address potential compliance issues before they escalate.
              </p>
            </div>
          </div>

        </div>

      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        .why-section {
          padding: 100px 0;
          background: linear-gradient(180deg, #ffffff 0%, #f4f8ff 100%);
          position: relative;
          overflow: hidden;
        }

        .main-title {
          font-size: 42px;
          font-weight: 800;
          text-align: center;
          margin-bottom: 60px;
          color: #0f172a;
        }

        .main-title span {
          color: #115886;
          background: linear-gradient(135deg, #115886, #89c764);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        /* Card */
        .why-card {
          background: #fff;
          padding: 35px 28px;
          border-radius: 24px;
          box-shadow: 0 10px 30px rgba(17, 88, 134, 0.02);
          text-align: center;
          transition: all 0.4s ease;
          height: 100%;
          border: 1px solid rgba(17, 88, 134, 0.08);
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .why-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 45px rgba(17, 88, 134, 0.08);
          border-color: rgba(137, 199, 100, 0.4);
        }

        .why-img-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f8fbff;
          border-radius: 50%;
          width: 90px;
          height: 90px;
          margin-bottom: 20px;
          transition: all 0.4s ease;
          border: 1px solid rgba(17, 88, 134, 0.04);
          overflow: hidden;
        }

        .why-card:hover .why-img-wrapper {
          background: rgba(137, 199, 100, 0.12);
          transform: scale(1.1) rotate(6deg);
          border-color: rgba(137, 199, 100, 0.2);
        }

        .why-card img {
          width: 65px;
          height: 65px;
          object-fit: contain;
          transition: transform 0.4s ease;
        }

        .why-card h4 {
          color: #115886;
          font-weight: 700;
          margin-bottom: 12px;
          font-size: 20px;
          transition: color 0.3s ease;
        }

        .why-card:hover h4 {
          color: #89c764;
        }

        .why-card p {
          color: #64748b;
          font-size: 14.5px;
          margin-bottom: 0;
          line-height: 1.7;
        }

        /* Decorative Background Blob */
        .why-section::after {
          content: "";
          position: absolute;
          width: 300px;
          height: 300px;
          background: rgba(17, 88, 134, 0.04);
          border-radius: 50%;
          right: -100px;
          bottom: 10%;
          filter: blur(100px);
          pointer-events: none;
        }

        /* Responsive */
        @media (max-width: 991px) {
          .main-title {
            font-size: 36px;
          }
        }

        @media (max-width: 768px) {
          .main-title {
            font-size: 30px;
            margin-bottom: 40px;
          }
          .why-section {
            padding: 70px 0;
          }
          .why-card {
            padding: 28px 20px;
          }
        }
      `}} />
    </section>
  );
}

export default WhyChooseUs;